export const CCPA_ANALYTICS = "pennsylvania_squeeze_analytics";
export const CCPA_MARKETING = "pennsylvania_squeeze_marketing";
export const CCPA_PERSONALIZATION = "pennsylvania_squeeze_personalization";
